var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEbs({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 135.161,
    height: 96.747,
    viewBox: "0 0 135.161 96.747",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-2, .cls-3 {\r\n        fill: #1d4754;\r\n      }\r\n\r\n      .cls-2 {\r\n        font-size: 8px;\r\n        font-family: Arial-BoldMT, Arial;\r\n        font-weight: 700;\r\n      }\r\n\r\n      .cls-3 {\r\n        font-size: 7px;\r\n        font-family: ArialMT, Arial;\r\n      }\r\n\r\n      .cls-4, .cls-6, .cls-7, .cls-8, .cls-9 {\r\n        fill: none;\r\n        stroke-miterlimit: 10;\r\n      }\r\n\r\n      .cls-4, .cls-6, .cls-8, .cls-9 {\r\n        stroke: #1d4754;\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-6 {\r\n        stroke-width: 2px;\r\n      }\r\n\r\n      .cls-7 {\r\n        stroke: #fff;\r\n        stroke-width: 0.25px;\r\n      }\r\n\r\n      .cls-8 {\r\n        stroke-width: 0.3px;\r\n      }\r\n\r\n      .cls-9 {\r\n        stroke-width: 0.5px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "EBS",
    transform: "translate(-193.27 -87.71)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    className: "cls-1",
    d: "M288.724,87.71A39.588,39.588,0,0,0,260.85,99.147a39.707,39.707,0,1,0,0,56.539A39.7,39.7,0,1,0,288.724,87.71Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(218.206 169.216)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(5.794)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Electronic_Business",
    "data-name": "Electronic Business",
    className: "cls-2",
    transform: "translate(0 7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Electronic Business"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27",
    transform: "translate(-0.414)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(29.331 8.24)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Solution",
    className: "cls-3",
    transform: "translate(0 6)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Solution"))), /*#__PURE__*/React.createElement("line", {
    id: "Line_1",
    "data-name": "Line 1",
    className: "cls-4",
    x2: 27.833,
    transform: "translate(0.208 13.213)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    className: "cls-4",
    x2: 27.833,
    transform: "translate(58.904 12.906)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(212.219 109.074)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    className: "cls-5",
    d: "M245.29,143.781v9.07H216.73V114.89h28.56v8.764H228.159v6.316h46.16v6.809h-46.16v7.011H245.29Z",
    transform: "translate(-216.73 -114.3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    className: "cls-5",
    d: "M279.04,152.712v-8.344h33.116q4.4,0,4.394-2.334a2.166,2.166,0,0,0-1.018-1.906,11.078,11.078,0,0,0-3.627-1.212q-9.983-1.914-12.818-5a10.4,10.4,0,0,1-2.835-7.261,11.378,11.378,0,0,1,4.071-8.933q4.071-3.562,11.72-3.562,11.595,0,15.322,9.313l-9.652,2.924q-1.5-3.8-6.09-3.812-3.816,0-3.812,2.367a1.873,1.873,0,0,0,.864,1.64,10.674,10.674,0,0,0,3.336,1.115,69.989,69.989,0,0,1,9.684,2.552,10.458,10.458,0,0,1,4.782,3.8,10.63,10.63,0,0,1,1.914,6.332,11.229,11.229,0,0,1-4.669,9.337c-3.11,2.383-5.7,2.988-10.759,2.988Z",
    transform: "translate(-228.712 -114.16)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    className: "cls-5",
    d: "M282.968,133.128a8.177,8.177,0,0,0,4.774-3.158,8.755,8.755,0,0,0,1.6-5.129,10.015,10.015,0,0,0-2.754-6.922q-2.75-3.029-8.764-3.029H258.552v10.646h8.311v-2.5h7.625q3.889,0,3.893,3.174a3.428,3.428,0,0,1-.832,2.2c-.557.687-1.51,1.833-2.867,1.833h-5.4l-10.9-.275.162,6.728h16.017a4.813,4.813,0,0,1,3.522,1.906,3.6,3.6,0,0,1,.961,2.407,3.346,3.346,0,0,1-.985,2.35,4.1,4.1,0,0,1-3.1,1.042h-8.093v-3.3H258.56v11.76h18.076q8.505,0,11.114-3.32a11.908,11.908,0,0,0,2.6-7.552Q290.326,134.9,282.968,133.128Z",
    transform: "translate(-224.741 -114.3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(285.792 109.058)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(5.153)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    className: "cls-1",
    cx: 1.123,
    cy: 1.236,
    rx: 1.123,
    ry: 1.236,
    transform: "translate(0 2.496)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    className: "cls-1",
    d: "M330.664,115.529H323.75V114.14h2.367a20.322,20.322,0,0,1,2.391.565,16.32,16.32,0,0,1,1.89.7A2.037,2.037,0,0,1,330.664,115.529Z",
    transform: "translate(-316.036 -114.14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    className: "cls-1",
    d: "M320.755,118.356l3.053-3.36-.775-.856-3.053,3.36Z",
    transform: "translate(-315.311 -114.14)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    className: "cls-1",
    width: 4.774,
    height: 0.945,
    transform: "translate(0.67 3.263)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(0.856 3.336)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    className: "cls-1",
    width: 0.913,
    height: 2.803,
    transform: "translate(0.67 1.381)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    className: "cls-1",
    cx: 1.123,
    cy: 1.236,
    rx: 1.123,
    ry: 1.236,
    transform: "translate(0 0.145)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    className: "cls-1",
    width: 8.965,
    height: 1.381,
    transform: "translate(12.576)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    className: "cls-1",
    d: "M321.445,122.478l3.053-3.352-.775-.856-3.053,3.36Z",
    transform: "translate(-311.147 -118.27)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    className: "cls-1",
    width: 9.604,
    height: 0.945,
    transform: "translate(0.695 3.255)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    className: "cls-1",
    cx: 1.123,
    cy: 1.236,
    rx: 1.123,
    ry: 1.236,
    transform: "translate(7.964 0.153)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    className: "cls-1",
    d: "M317,115.317v.848H307.82l1.163-.9Z",
    transform: "translate(-307.82 -114.355)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    className: "cls-1",
    d: "M328.11,156.69l.985,2.552.339-.792.808.977.267-.226-.84-.945.84-.242Z",
    transform: "translate(-25.93 -13.265)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    className: "cls-6",
    d: "M329.646,150.2h8.36a2.332,2.332,0,0,0,2.326-2.326v-3.893a2.332,2.332,0,0,0-2.326-2.326h-8.36a2.332,2.332,0,0,0-2.326,2.326v3.893A2.337,2.337,0,0,0,329.646,150.2Z",
    transform: "translate(-25.778 -10.373)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    className: "cls-1",
    d: "M340.316,147.623h-9.523a.741.741,0,0,1-.743-.743V146.4a.741.741,0,0,1,.743-.743h9.523a.741.741,0,0,1,.743.743v.477A.752.752,0,0,1,340.316,147.623Z",
    transform: "translate(-26.303 -11.144)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    className: "cls-7",
    cx: 0.46,
    cy: 0.46,
    r: 0.46,
    transform: "translate(304.66 134.952)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    className: "cls-5",
    d: "M332.727,147.672l-.065.065a.112.112,0,0,1-.153,0l-.436-.436a.112.112,0,0,1,0-.153l.065-.065a.112.112,0,0,1,.153,0l.436.436A.112.112,0,0,1,332.727,147.672Z",
    transform: "translate(-26.686 -11.412)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    className: "cls-1",
    d: "M339.052,154.4h-4.4l.646-2.173h2.924Z",
    transform: "translate(-27.187 -12.407)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(306.021 114.841)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    className: "cls-1",
    d: "M334.828,121.542a.315.315,0,1,0,.525-.242A.861.861,0,0,0,334.828,121.542Z",
    transform: "translate(-333.208 -121.3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    className: "cls-1",
    d: "M335.656,122.687a.924.924,0,0,0-1.187-.242.4.4,0,0,1-.307,0c-1.381-.549-1.712,1.4-.735,2.431.339.363.477.089.9.04h.016c.258-.048.606.331.937,0a2.368,2.368,0,0,0,.477-.808A.808.808,0,0,1,335.656,122.687Z",
    transform: "translate(-332.865 -121.5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(280.413 114.437)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    className: "cls-1",
    d: "M303.64,123.2h2.682v-2.4l-2.682.533Z",
    transform: "translate(-301.637 -120.8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    className: "cls-1",
    d: "M303.64,126.138l2.682.525V124.24H303.64Z",
    transform: "translate(-301.637 -121.462)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    className: "cls-1",
    d: "M301.16,123.332h1.656V121.49l-1.656.339Z",
    transform: "translate(-301.16 -120.933)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    className: "cls-1",
    d: "M301.16,125.75l1.656.339v-1.85H301.16Z",
    transform: "translate(-301.16 -121.462)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    transform: "translate(278.725 119.638)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    className: "cls-8",
    cx: 2.52,
    cy: 2.52,
    r: 2.52
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3",
    "data-name": "Line 3",
    className: "cls-8",
    x2: 4.144,
    transform: "translate(0.46 1.058)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4",
    "data-name": "Line 4",
    className: "cls-8",
    x2: 4.144,
    transform: "translate(0.46 3.974)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5",
    "data-name": "Line 5",
    className: "cls-8",
    x2: 5.04,
    transform: "translate(0 2.52)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6",
    "data-name": "Line 6",
    className: "cls-8",
    y2: 5.04,
    transform: "translate(2.52)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    className: "cls-8",
    cx: 1.333,
    cy: 2.52,
    rx: 1.333,
    ry: 2.52,
    transform: "translate(1.179)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(281.083 122.788)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    className: "cls-1",
    cx: 2.609,
    cy: 2.609,
    r: 2.609,
    transform: "translate(2.027)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    className: "cls-1",
    d: "M303.937,138.263h5.282a1.953,1.953,0,0,0,1.947-1.947h0a1.953,1.953,0,0,0-1.947-1.947h-5.282a1.953,1.953,0,0,0-1.947,1.947h0A1.948,1.948,0,0,0,303.937,138.263Z",
    transform: "translate(-301.99 -131.761)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    transform: "translate(285.512 117.212)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    className: "cls-1",
    d: "M310.087,124.344l-2.35,1.607a.618.618,0,0,0-.162.848l3.812,5.589a.618.618,0,0,0,.848.162l2.35-1.607a.618.618,0,0,0,.162-.848l-3.812-5.589A.6.6,0,0,0,310.087,124.344Zm4.362,5.727-2.972,2.027-3.594-5.274,2.972-2.027Z",
    transform: "translate(-307.473 -124.236)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    className: "cls-1",
    d: "M312.257,128.085a.892.892,0,0,0-1.47,1.01Z",
    transform: "translate(-308.083 -124.907)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    className: "cls-1",
    width: 1.575,
    height: 1.575,
    transform: "translate(2.939 4.303) rotate(-34.311)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    className: "cls-1",
    d: "M311.508,130.849h0a.191.191,0,0,1-.258-.048l-.517-.759a.191.191,0,0,1,.048-.258h0a.191.191,0,0,1,.258.048l.517.759A.19.19,0,0,1,311.508,130.849Z",
    transform: "translate(-308.094 -125.296)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    className: "cls-1",
    d: "M313.708,129.349h0a.192.192,0,0,1-.258-.048l-.517-.759a.191.191,0,0,1,.048-.258h0a.191.191,0,0,1,.258.048l.517.759A.19.19,0,0,1,313.708,129.349Z",
    transform: "translate(-308.517 -125.008)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    className: "cls-1",
    d: "M313.688,130.939h0a.192.192,0,0,1-.258-.048l-.517-.759a.191.191,0,0,1,.048-.258h0a.191.191,0,0,1,.258.048l.517.759A.193.193,0,0,1,313.688,130.939Z",
    transform: "translate(-308.513 -125.314)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    className: "cls-1",
    d: "M313.058,131.359h0a.191.191,0,0,1-.258-.048l-.517-.759a.191.191,0,0,1,.048-.258h0a.191.191,0,0,1,.258.048l.517.759A.19.19,0,0,1,313.058,131.359Z",
    transform: "translate(-308.392 -125.394)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    transform: "translate(290.065 127.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    className: "cls-1",
    d: "M317.346,138.318a1.584,1.584,0,1,0-3.166,0Z",
    transform: "translate(-313.316 -136.67)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13",
    "data-name": "Rectangle 13",
    className: "cls-1",
    width: 3.037,
    height: 3.037,
    transform: "translate(0.937 1.882)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    className: "cls-1",
    d: "M313.465,141.488h0a.359.359,0,0,1-.355-.355v-1.777a.359.359,0,0,1,.355-.355h0a.359.359,0,0,1,.355.355v1.777A.359.359,0,0,1,313.465,141.488Z",
    transform: "translate(-313.11 -137.118)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    className: "cls-1",
    d: "M318.585,141.488h0a.359.359,0,0,1-.355-.355v-1.777a.359.359,0,0,1,.355-.355h0a.359.359,0,0,1,.355.355v1.777A.359.359,0,0,1,318.585,141.488Z",
    transform: "translate(-314.095 -137.118)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    className: "cls-1",
    d: "M316.835,143.978h0a.359.359,0,0,1-.355-.355v-1.777a.359.359,0,0,1,.355-.355h0a.359.359,0,0,1,.355.355v1.777A.359.359,0,0,1,316.835,143.978Z",
    transform: "translate(-313.758 -137.597)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    className: "cls-1",
    d: "M315.375,143.978h0a.359.359,0,0,1-.355-.355v-1.777a.359.359,0,0,1,.355-.355h0a.359.359,0,0,1,.355.355v1.777A.359.359,0,0,1,315.375,143.978Z",
    transform: "translate(-313.477 -137.597)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    className: "cls-1",
    d: "M329.65,132.284l-1.389-.444-2.851,1.082v3.061l.872-.331.024-2.552,1.825-.4v3.651l-2.439-.283,2.439.945,1.518-.4Z",
    transform: "translate(-25.41 -8.486)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    transform: "translate(278.159 139.823)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    className: "cls-1",
    cx: 1.123,
    cy: 1.236,
    rx: 1.123,
    ry: 1.236,
    transform: "translate(12.39 2.496)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    className: "cls-1",
    d: "M298.378,153.619h6.914V152.23H298.37v1.389C298.467,153.571,298.459,153.571,298.378,153.619Z",
    transform: "translate(-298.37 -152.23)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    className: "cls-1",
    d: "M309.021,156.446l-3.061-3.36.783-.856,3.053,3.36Z",
    transform: "translate(-299.83 -152.23)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14",
    "data-name": "Rectangle 14",
    className: "cls-1",
    width: 4.774,
    height: 0.945,
    transform: "translate(9.192 3.263)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19",
    transform: "translate(0.008 3.263)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15",
    "data-name": "Rectangle 15",
    className: "cls-1",
    width: 0.913,
    height: 2.803,
    transform: "translate(17.341 1.454)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    className: "cls-1",
    cx: 1.123,
    cy: 1.236,
    rx: 1.123,
    ry: 1.236,
    transform: "translate(16.679 0.218)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    className: "cls-1",
    width: 6.357,
    height: 1.454
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    className: "cls-1",
    d: "M308.333,160.568l-3.053-3.352.775-.856,3.053,3.36Z",
    transform: "translate(-299.707 -156.287)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    className: "cls-1",
    width: 9.604,
    height: 0.945,
    transform: "translate(8.626 3.336)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    className: "cls-1",
    cx: 1.123,
    cy: 1.236,
    rx: 1.123,
    ry: 1.236,
    transform: "translate(9.579 0.153)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    className: "cls-1",
    d: "M311.5,153.407v.848h8.327v-.9Z",
    transform: "translate(-300.895 -152.445)"
  })))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    className: "cls-9",
    cx: 1.664,
    cy: 1.664,
    r: 1.664,
    transform: "translate(299.773 115.446)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    className: "cls-1",
    d: "M330.853,127.109l-.614.614a.112.112,0,0,1-.153,0l-1.963-1.963a.112.112,0,0,1,0-.153l.614-.614a.112.112,0,0,1,.153,0l1.963,1.963A.112.112,0,0,1,330.853,127.109Z",
    transform: "translate(-25.926 -7.164)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    className: "cls-1",
    d: "M324.271,141.3l-2.73.234.662.557-1.163.5.145.323,1.147-.541-.008.872Z",
    transform: "translate(-24.57 -10.305)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23",
    transform: "translate(278.757 145.404)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    className: "cls-1",
    d: "M299.514,159.511l-.4,2.084a.456.456,0,0,0,.363.533l4.951.937a.456.456,0,0,0,.533-.363l.4-2.084a.456.456,0,0,0-.363-.533l-4.951-.937A.458.458,0,0,0,299.514,159.511Zm5.315.719-.5,2.633-4.669-.88.5-2.633Z",
    transform: "translate(-299.109 -159.14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    className: "cls-1",
    d: "M302.449,160.588a.663.663,0,0,0-.25,1.3Z",
    transform: "translate(-299.605 -159.417)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18",
    "data-name": "Rectangle 18",
    className: "cls-1",
    width: 1.179,
    height: 1.179,
    transform: "translate(2.782 2.427) rotate(-79.309)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    className: "cls-1",
    d: "M303.453,162.561h0a.15.15,0,0,1-.162.113l-.678-.129a.15.15,0,0,1-.113-.162h0a.15.15,0,0,1,.162-.113l.678.129A.137.137,0,0,1,303.453,162.561Z",
    transform: "translate(-299.761 -159.741)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    className: "cls-1",
    d: "M303.823,160.611h0a.15.15,0,0,1-.162.113l-.678-.129a.15.15,0,0,1-.113-.162h0a.15.15,0,0,1,.162-.113l.678.129A.137.137,0,0,1,303.823,160.611Z",
    transform: "translate(-299.832 -159.366)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    className: "cls-1",
    d: "M304.643,161.461h0a.15.15,0,0,1-.162.113l-.678-.129a.15.15,0,0,1-.113-.162h0a.15.15,0,0,1,.162-.113l.678.129A.137.137,0,0,1,304.643,161.461Z",
    transform: "translate(-299.99 -159.53)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    className: "cls-1",
    d: "M304.543,162.011h0a.15.15,0,0,1-.162.113l-.678-.129a.15.15,0,0,1-.113-.162h0a.15.15,0,0,1,.162-.113l.678.129A.143.143,0,0,1,304.543,162.011Z",
    transform: "translate(-299.971 -159.636)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    className: "cls-1",
    d: "M321.921,127.71h-2.69a.584.584,0,0,0-.582.582v6.4a.584.584,0,0,0,.582.582h2.69a.584.584,0,0,0,.582-.582v-6.4A.579.579,0,0,0,321.921,127.71Zm.355,6.793h-3.4v-6.034h3.4Z",
    transform: "translate(-24.11 -7.692)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24",
    transform: "translate(295.724 122.869)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    className: "cls-1",
    d: "M321.129,131.369a.454.454,0,0,0-.089.283.447.447,0,0,0,.267-.129.454.454,0,0,0,.089-.283A.447.447,0,0,0,321.129,131.369Z",
    transform: "translate(-320.294 -131.24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    className: "cls-1",
    d: "M321.557,131.957a.468.468,0,0,0-.614-.121.223.223,0,0,1-.162,0c-.711-.283-.88.727-.372,1.252.178.186.242.048.46.024h.008c.137-.024.315.17.485,0a1.191,1.191,0,0,0,.25-.42A.416.416,0,0,1,321.557,131.957Z",
    transform: "translate(-320.116 -131.343)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25",
    transform: "translate(299.733 127.845)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19",
    "data-name": "Rectangle 19",
    className: "cls-1",
    width: 0.452,
    height: 1.397,
    transform: "translate(0.796 2.098) rotate(180)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    className: "cls-1",
    cx: 0.565,
    cy: 0.622,
    rx: 0.565,
    ry: 0.622,
    transform: "translate(0 0.073)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20",
    "data-name": "Rectangle 20",
    className: "cls-1",
    width: 4.483,
    height: 0.695,
    transform: "translate(10.777 0.7) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    className: "cls-1",
    d: "M331.368,139.508l1.527-1.68-.388-.428-1.527,1.68Z",
    transform: "translate(-326.215 -137.4)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21",
    "data-name": "Rectangle 21",
    className: "cls-1",
    width: 4.798,
    height: 0.477,
    transform: "translate(5.155 2.109) rotate(180)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26",
    transform: "translate(297.568 139.411)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    className: "cls-8",
    cx: 2.52,
    cy: 2.52,
    r: 2.52
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_7",
    "data-name": "Line 7",
    className: "cls-8",
    x2: 4.144,
    transform: "translate(0.468 1.058)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_8",
    "data-name": "Line 8",
    className: "cls-8",
    x2: 4.144,
    transform: "translate(0.468 3.982)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9",
    "data-name": "Line 9",
    className: "cls-8",
    x2: 5.04,
    transform: "translate(0 2.52)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10",
    "data-name": "Line 10",
    className: "cls-8",
    y2: 5.04,
    transform: "translate(2.52)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    className: "cls-8",
    cx: 1.333,
    cy: 2.52,
    rx: 1.333,
    ry: 2.52,
    transform: "translate(1.187)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEbs);
export default __webpack_public_path__ + "static/media/EBS.f007e50b9ca2c71ccef31cda165b9da5.svg";
export { ForwardRef as ReactComponent };